import React, { memo, useCallback } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { OkedSelect } from '@app/components';
import { SelectOption } from 'components/Select';
import { Oked } from '@app/models';

interface OkedModalProps {
  visible: boolean;
  onChange: (value: SelectOption<Oked>) => void;
  onClose?: () => void;
  parentNumber?: number;
}

function OkedModal(props: OkedModalProps) {
  const { visible, onChange, onClose, parentNumber } = props;

  const onClickClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <Dialog open={visible} onOpenChange={onClickClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Выберите сферу деятельности</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <OkedSelect onChange={onChange} parentNumber={parentNumber} />
        </div>
        <DialogFooter>
          <Button onClick={onClickClose}>Выбрать</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default memo(OkedModal);
